import { render } from "./DashboardV2Page.vue?vue&type=template&id=039c4291"
import script from "./DashboardV2Page.vue?vue&type=script&lang=js"
export * from "./DashboardV2Page.vue?vue&type=script&lang=js"

import "./DashboardV2Page.vue?vue&type=style&index=0&id=039c4291&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__